import { autorun, computed, makeObservable, observable, runInAction } from "mobx";
import { type PublicSetting } from "../../api";
import { type UUID } from "../../utils/uuid";
import type { ServiceOwnUser } from "./service-own-user";
import { store } from "../../store";

export class ServicePublicSettings {
    @observable private accessor publicSettingId: UUID | undefined;

    constructor(private readonly serviceOwnUser: ServiceOwnUser) {
        makeObservable(this);

        autorun(() => {
            if (this.serviceOwnUser.user === undefined) {
                return;
            }

            // Pull the settings if they haven't been pulled yet.
            if (!this.publicSetting) {
                store.publicSettingsApi.publicSettingsReadPublicSetting().then((result) => {
                    runInAction(() => {
                        this.publicSettingId = result.id;
                    });
                });
            }
        });

        autorun(() => {
            if (this.publicSetting && this.publicSetting.instanceName !== "ELOfleet") {
                document.title = `ELOfleet - ${this.publicSetting.instanceName}`;
            } else if (!this.serviceOwnUser.user) {
                document.title = "Login";
            } else {
                document.title = "ELOfleet";
            }
        });
    }

    @computed public get publicSetting(): PublicSetting | undefined {
        if (this.publicSettingId === undefined) {
            return;
        }
        return store.repositoryPublicSettings.byId(this.publicSettingId);
    }
}
